"use strict";

var _defineProperty = require("/codebuild/output/src1656618240/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var genLayoutLightStyle = function genLayoutLightStyle(token) {
  var _$concat;

  var componentCls = token.componentCls,
      colorBgContainer = token.colorBgContainer,
      colorBgBody = token.colorBgBody,
      colorText = token.colorText;
  return _defineProperty({}, "".concat(componentCls, "-sider-light"), (_$concat = {
    background: colorBgContainer
  }, _defineProperty(_$concat, "".concat(componentCls, "-sider-trigger"), {
    color: colorText,
    background: colorBgContainer
  }), _defineProperty(_$concat, "".concat(componentCls, "-sider-zero-width-trigger"), {
    color: colorText,
    background: colorBgContainer,
    border: "1px solid ".concat(colorBgBody),
    borderInlineStart: 0
  }), _$concat));
};

var _default = genLayoutLightStyle;
exports.default = _default;